import { ButtonIconActiveHeight } from '@kit/components/IconButton.vue'
import { orangeButton, blueButton, greenButton,
  navMainSearchButton, roundCloseButton, 
  navSearchWidgetButton, prevNextSearchResultsButton
} from '@project/theme-buttons'
import { ModalPositionCenter } from '@kit/components/Modal.vue'


  export const blueModal = {
    windowAutoPosition: true,
    position: ModalPositionCenter,
    windowClasses: "fbicc-modal-window",
    backgroundClasses: "fbicc-modal-background",
    closeButton: {
      ...blueButton, 
      icon:"rounded-close-x_50", 
      iconDimension: {
        style: ButtonIconActiveHeight,
        active: "20px"
      },
      background: {
        ...blueButton.background,
        borderRadius: "50%"   
      },
    }
  }

  

  export const searchResultsModal = {

    suspendScrolling: true,
    
    backgroundStyle: "opacity:0.8; background-color:#FFFFFF;",
    
    windowStyles: "background:#FFFFFF; box-shadow:6px 6px 5px #999999; border-radius:10px; border-left:2px solid #DDDDDD; border-top:2px solid #DDDDDD;",

    vw: 80,
    vh: 80,
    mvw: 80,
    mvh: 80,
    position: ModalPositionCenter,

    closeButton: roundCloseButton
  }

  export const searchResults = {

    //show the thumbnails for the search results?
    showThumbnails: false,

    //The mergeable classes for the outer wrapper. See mergeClassesTheme 
    //outerClasses: "fbicc-search-results-outer",

    //The mergable classes for the button container
    buttonClasses: "fbicc-search-results-prevnext-wrapper",

    //the mergable classes for the results-block
    resultsBlockClasses: "fbicc-results-block",

    //the mergeable clases for each the result element
    resultElementClasses: "fbicc-search-result",

    //The mergeable classes for the loading wrapper. See mergeClassesTheme 
    loadingClasses: "fbicc-search-loading",

    //the theme for the buttons, and the icon for each
    prevNextButton: prevNextSearchResultsButton,

    prevIcon:"rounded-single-chevron-left",
    nextIcon:"rounded-single-chevron-right",
  }

  //The theme for the search results component in the modal.
  export const searchResultsInModal = {
    ...searchResults,
    outerClasses: "sb-greedy fbicc-search-results-outer",
  }


  export const searchWidgetMain = {
  
    //The height of the widget
    mainWidgetHeight:60,

    //The height of the drop-shadow at the bottom. 
    shadowAdjustment:5,

    //Show the thumbnails
    showThumbnails: false,

    //the options for the navigation item in the top menu.
    navComponent: {

      outerClasses: "sb sb-h sb-explicit sb-alt2 sb-align-c fbicc-nav-main-searchoption",
      
      button: navMainSearchButton,

    },

    //the place to put the classes and styles for the search widget modal
    searchComponent: {
      
      modalMode:false,
      //The two headlines in the search modal window
      topHeadline: "Search",
      mainHeadline: "Search FBICC",
      mainHeadlineClasses: "fbicc-main-search-widget-headline",

      completionWrapperClasses:"fbicc-main-search-completion-wrapper",

      completionResultClasses:"fbicc-main-completion-result",

      //non-modal style
      //searchButton: {...orangeButton, text:"GO" },
      searchButton: navSearchWidgetButton
      //{ ...magnifyingGlassButton, outerClasses:"fbicc-search-modal-search-nonmodal-button" },
        
    },

    //The options for the search-results.
    resultsComponent: {

      //the theme for the search
      searchResults: searchResultsInModal,

      //the modal theme, for use in the event that route is null
      modal: searchResultsModal
    }
  }
 
   
  export const searchWidgetMobile = {

    ...searchWidgetMain,

    isMobile: true,

    //the options for the navigation item in the top menu.
    navComponent: {
      button: { 
        ...blueButton, 
        icon:"rounded-magnifying-glass",
        foreground: "#FFFFFF",
        background: {  
          ...blueButton.background,
          padding:      "20px", 
          borderRadius: "5px"    
        },
        iconDimension: {
          style: ButtonIconActiveHeight,
          active: '30px'
        },
        outerClasses:"sb-explicit fbicc-mobile-search-button"
      },


      //the mergeable classes for the outer-wrapper
      outerClasses: "fbicc-mobile-search-wrapper",

      completionWrapperClasses:"fbicc-mobile-search-completion-wrapper",

      completionResultClasses:"fbicc-mobile-completion-result",

      completionUnderPosition: false,

      //the mergeable classes for the headline
      headlineClasses: "fbicc-mobile-search-headline",
    
      headline:"Search HTA"

    },
    
  } 
  
